(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-presence-header"]) return;
  try {
    
function initPresenceMenu(){
 const dialog=document.getElementById('ap-menu');const trigger=document.querySelector('[data-ap-open]');
 if(!dialog||!trigger||trigger.dataset.ready)return;trigger.dataset.ready='true';
 const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
 function closeMenu(){
  if(!dialog.open||dialog.classList.contains('is-closing'))return;
  if(reduceMotion.matches){dialog.close();return;}
  dialog.classList.add('is-closing');
  let done=false;
  const finish=()=>{if(done)return;done=true;dialog.classList.remove('is-closing');if(dialog.open)dialog.close();};
  dialog.addEventListener('animationend',finish,{once:true});
  setTimeout(finish,320);
 }
 trigger.addEventListener('click',()=>{const cart=document.getElementById('cart-drawer');if(cart&&typeof cart.hide==='function')cart.hide();dialog.classList.remove('is-closing');dialog.showModal();trigger.setAttribute('aria-expanded','true');selectTab(dialog.querySelector('#ap-tab-shop'));});
 dialog.addEventListener('close',()=>{dialog.classList.remove('is-closing');trigger.setAttribute('aria-expanded','false');trigger.focus();});
 dialog.addEventListener('cancel',event=>{event.preventDefault();closeMenu();});
 const closeForm=dialog.querySelector('.ap-menu-head form');
 if(closeForm)closeForm.addEventListener('submit',event=>{event.preventDefault();closeMenu();});
 dialog.addEventListener('click',event=>{const r=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))closeMenu();});
 const tabs=[...dialog.querySelectorAll('[role="tab"]')];
 function selectTab(tab){tabs.forEach(t=>{const on=t===tab;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;dialog.querySelector('#'+t.getAttribute('aria-controls')).hidden=!on;});}
 tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>selectTab(tab));tab.addEventListener('keydown',event=>{let j;if(event.key==='ArrowRight')j=(i+1)%tabs.length;if(event.key==='ArrowLeft')j=(i+tabs.length-1)%tabs.length;if(event.key==='Home')j=0;if(event.key==='End')j=tabs.length-1;if(j!==undefined){event.preventDefault();selectTab(tabs[j]);tabs[j].focus();}});});
 dialog.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{if(detail.open)dialog.querySelectorAll('details').forEach(other=>{if(other!==detail)other.open=false;});}));
}
initPresenceMenu();document.addEventListener('shopify:section:load',initPresenceMenu);

  } catch(e) { console.error(e); }
})();
})();
